export default __webpack_public_path__ + "static/media/slide_14.15e029d1.jpg";